// Utility functions to mimic jQuery animations
function slideUp(el) {
  el.style.transition = 'max-height 0.5s ease-out';
  el.style.overflow = 'hidden';
  el.style.maxHeight = '0';
  el.style.padding = '0';
}

function slideDown(el) {
  el.style.display = 'block';
  el.style.transition = 'max-height 0.5s ease-in';
  el.style.overflow = 'hidden';
  el.style.maxHeight = el.scrollHeight + 'px';
}

function fadeIn(el) {
  el.style.opacity = 0;
  el.style.display = 'inline-block';
  let last = +new Date();
  const tick = function () {
    el.style.opacity = +el.style.opacity + (new Date() - last) / 400;
    last = +new Date();
    if (+el.style.opacity < 1) {
      requestAnimationFrame(tick);
    }
  };
  tick();
}

// Download Quote Button
const downloadQuoteBtn = document.querySelector('.btn-download-quote-list');

if (downloadQuoteBtn) {
    downloadQuoteBtn.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelectorAll('.dbm-cart').forEach(el => slideUp(el));

    document.querySelectorAll('.enquirySection:not(.productEnquirySuccessWrap)')
        .forEach(el => slideDown(el));
    });
}

// Enquiry Form Validation & Submission
document.querySelectorAll('.enquiryForm').forEach(form => {
  const submitBtn = form.querySelector('.enquirySubmitBtnWrap input');
  const loader = form.querySelector('.formLoader');
  const messageBox = form.querySelector('.successOrMessage');

  // Simple validation rules (you can extend or modularize this)
  const validateForm = () => {
    let valid = true;
    const rules = {
      enquiryName: "Please provide your name",
      enquiryEmail: "Please provide a valid email address",
      enquiryPhoneNumber: "Please provide your phone number",
      enquiryMessage: "Please provide message",
      enquiryAddress: "Please provide your address",
      enquiryPostCode: "Please provide your post code",
      enquiryBranch: "Please select a branch"
    };

    for (const fieldName in rules) {
      const field = form.querySelector(`[name="${fieldName}"]`);
      if (field) {
        const value = field.value.trim();
        const isEmail = fieldName === 'enquiryEmail';
        const isValid = isEmail ? /\S+@\S+\.\S+/.test(value) : value !== '';

        field.classList.toggle('error', !isValid);
        if (!isValid) {
          field.closest('.form-group').querySelector('.error-message')?.remove();
          const errorMsg = document.createElement('div');
          errorMsg.className = 'error-message';
          errorMsg.textContent = rules[fieldName];
          field.closest('.form-group').appendChild(errorMsg);
          valid = false;
        } else {
          field.closest('.form-group').querySelector('.error-message')?.remove();
        }
      }
    }

    return valid;
  };

  // Submit Button Click
  submitBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (validateForm()) {
      form.dispatchEvent(new Event('submit'));
    }
  });

  // Form Submit Handler
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const formData = new FormData(form);
    submitBtn.disabled = true;
    loader.style.display = 'inline-block';
    fadeIn(loader);
    messageBox.innerHTML = '';
    messageBox.style.display = 'none';

    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        formData.append('cart', JSON.stringify(cartData));
        // formData.append('success', true);
        // console.log([...formData]);
        // return formData;
        return fetch('https://dbm.eqserver.net/index.php/app/email', {
          method: 'POST',
          body: formData
        });
      })
      .then(response => response.json())
      .then(data => {
        loader.style.display = 'none';

        if (data.success === 'true') {
          fetch('/cart/clear');
          form.reset();
          submitBtn.disabled = false;
          window.location.href = "/pages/quote-thanks";
        } else {
          submitBtn.disabled = false;
          messageBox.textContent = data.message || 'Something went wrong.';
          messageBox.style.display = 'block';
        }
      })
      .catch(() => {
        submitBtn.disabled = false;
        messageBox.textContent = 'Something went wrong. Try again later!';
        messageBox.style.display = 'block';
      });
  });
  

  let formSubmitted = false;
  submitBtn.addEventListener('click', function (e) {
    formSubmitted = true;
  });

  form.querySelectorAll('input, textarea, select').forEach(input => {
    input.addEventListener('input', () => {
      if (formSubmitted) {
        validateForm();
      }
    });
  });
});
